import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { DiffusionModelsButtonRentView } from '@/pages/page_diffusion_models/_base/rows/diffusion_models_button_rent_view';
import { DiffusionModelsCellExpiredAt } from '@/pages/page_diffusion_models/_base/rows/diffusion_models_cell_expired_at';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { render_table_cell_as_chip_colorized } from '@/utils/utils_renders';
import { DTODiffusionModelUDBase } from '@shared/dto/+diffusion_model/+ud/_base/dto_diffusion_model_ud_base';
import { ColumnDef } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { use_slice_ml_asset } from '../store/use_slices';

// info: for border blink use NotifierBorder component (parent component must have className="relative")
export function use_table_columns_diffusion_models_ud() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const { current_table } = use_slice_ml_asset(['current_table']);

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  /*
   * RESULT
   */

  return useMemo<ColumnDef<DTODiffusionModelUDBase>[]>(
    () => [
      {
        accessorKey: 'type',
        header: t(i18n_page_diffusion_models.table.ud.columns.type),
        cell: info => {
          let type = info.getValue() as string;
          type = type.replace('IMAGE_', ''); //todo: remove this

          return render_table_cell_as_chip_colorized(type, type);
        },
        size: 100,
      },
      {
        accessorKey: 'base_model',
        header: t(i18n_page_diffusion_models.table.ud.columns.base_model),
        cell: info => {
          let base_model = info.getValue() as string;
          base_model = base_model.replace('IMAGE_', ''); //todo: remove this

          return render_table_cell_as_chip_colorized(base_model, base_model);
        },
        size: 150,
      },
      {
        accessorKey: 'name',
        header: t(i18n_page_diffusion_models.table.ud.columns.name),
        cell: info => <span>{info.getValue() as string}</span>,
        size: 300,
      },
      {
        accessorKey: 'version',
        header: t(i18n_page_diffusion_models.table.ud.columns.version),
        cell: info => <span>{info.getValue() as string}</span>,
        size: 100,
      },
      {
        accessorKey: 'rent_price',
        header: t(i18n_page_diffusion_models.table.ud.columns.rent_price),
        cell: info => <DiffusionModelsButtonRentView diffusion_model={info.row.original} />,
        size: 200,
      },
      {
        accessorKey: 'expired_at',
        header: t(i18n_page_diffusion_models.table.ud.columns.expired_at),
        cell: info => <DiffusionModelsCellExpiredAt diffusion_model={info.row.original} />,
        size: 150,
      },
    ],
    [current_table, t],
  );
}
